import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateOrganizationSettingsRequest } from '@nucleus-commerce/api-client/admin';

import { session } from '@/shared/session/session';

import { organizationSettingsApi } from '../api/organization-settings-api';

import { organizationSettingsKeys } from './organization-settings-keys';

/**
 * 403 for anyone but an owner, 422 on `security.requireTwoFactor` when the owner has no
 * two-factor yet; the card explains both. /me carries `twoFactorRequired`, so it is refreshed.
 */
export function useUpdateOrganizationSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateOrganizationSettingsRequest) => organizationSettingsApi.update(body),
    meta: { successMessage: 'organization:toasts.saved', silentError: true },
    onSuccess: async (settings) => {
      queryClient.setQueryData(organizationSettingsKeys.all, settings);
      await session.refreshSession(queryClient);
    },
  });
}
